import React from 'react';
import { StepperPlaceholder } from 'app/components/styles/swipeableViews/StepperPlaceholder';
import { OnlyDesktop, OnlyMobile, View } from 'app/components/transferModule/content/commonStyles';
import { SkeletonAnimation } from 'app/types/SkeletonAnimation';
import TransferComponentSkeleton from 'app/components/transferModule/content/transfer/TransferComponentSkeleton';
const createArrayOfSkeletons = (length, key, animation) => Array.from({
  length
}, (_value, index) => /*#__PURE__*/React.createElement(TransferComponentSkeleton, {
  key: "transfer-component-skeleton-".concat(key, "-").concat(index),
  animation: animation
}));
export default function LoadingSkeleton(_ref) {
  let {
    animation = SkeletonAnimation.Pulse
  } = _ref;
  const mobileTransferSkeletons = createArrayOfSkeletons(4, 'mobile', animation);
  const desktopTransferSkeletons = createArrayOfSkeletons(6, 'desktop', animation);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnlyDesktop, {
    "data-sentry-element": "OnlyDesktop",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(View, {
    "data-sentry-element": "View",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, desktopTransferSkeletons)), /*#__PURE__*/React.createElement(OnlyMobile, {
    "data-sentry-element": "OnlyMobile",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(View, {
    "data-sentry-element": "View",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, mobileTransferSkeletons)), /*#__PURE__*/React.createElement(StepperPlaceholder, {
    "data-sentry-element": "StepperPlaceholder",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }));
}